// Reps : défi LÉGENDAIRE (parité app mobile) — constantes visuelles et
// marqueur local des défis réussis.
//
// Le nœud or du path est une DÉCORATION locale au navigateur (localStorage),
// même connecté : le serveur ne stocke pas le légendaire (intérim assumé,
// comme sur mobile où il vit dans le store local de l'appareil).

/** XP promis : plein tarif à la première réussite, tarif révision ensuite. */
export const LEGENDARY_XP = 40;
export const LEGENDARY_REVIEW_XP = 5;
/** Nombre d'erreurs permises avant l'échec. */
export const LEGENDARY_LIVES = 3;

/** Couleurs or (échantillonnées sur Duolingo, mêmes valeurs que l'app). */
export const LEGENDARY_COLORS = {
    base: "#F5C942",
    shine: "#FAD645",
    lip: "#DFAE35",
    text: "#6A3D00",
    // Accents or sur fonds CLAIRS (l'or de base ne porte que sur sombre) —
    // parité tokens mobile (colors.legendary.deep).
    deep: "#8A6D00",
};

/** Facettes diagonales du bouton or (dégradé à bords nets, comme Duolingo). */
export const LEGENDARY_FACETS = `linear-gradient(to top right, ${LEGENDARY_COLORS.base} 0%, ${LEGENDARY_COLORS.base} 26%, ${LEGENDARY_COLORS.shine} 26%, ${LEGENDARY_COLORS.shine} 44%, ${LEGENDARY_COLORS.base} 44%, ${LEGENDARY_COLORS.base} 62%, ${LEGENDARY_COLORS.shine} 62%, ${LEGENDARY_COLORS.shine} 80%, ${LEGENDARY_COLORS.base} 80%, ${LEGENDARY_COLORS.base} 100%)`;

const KEY = "reps_legendary";

/** Carte { codeCanonique: true } des défis légendaires réussis (ce navigateur). */
export function legendaryDoneMap() {
    if (typeof window === "undefined") return {};
    try {
        const raw = window.localStorage.getItem(KEY);
        const map = raw ? JSON.parse(raw) : null;
        return map && typeof map === "object" ? map : {};
    } catch (e) {
        return {};
    }
}

export function isLegendaryDone(code) {
    return code ? legendaryDoneMap()[code] === true : false;
}

export function markLegendaryDone(code) {
    if (!code || typeof window === "undefined") return;
    try {
        const map = legendaryDoneMap();
        if (map[code] === true) return;
        map[code] = true;
        window.localStorage.setItem(KEY, JSON.stringify(map));
    } catch (e) {
        // stockage indisponible : le nœud restera orange, sans conséquence
    }
}
